import AddGroupMember from './AddGroupMember.component';

export default AddGroupMember;